<template>
  <div>
    <Row class="expand-row">
      <Col span="24">
        <table style="width: 100%">
          <tr>
            <th>客户名称</th>
            <th>颜色</th>
            <th>规格</th>
            <th>件数</th>
            <th>金额</th>
            <th>日期</th>
          </tr>
          <tr v-for="(k,v) in row.marketGoodsItem" :key="v" align="center">
            <td>{{k.customername}}</td>
            <td>{{k.color}}</td>
            <td>{{k.size}}</td>
            <td>{{k.quantity}}</td>
            <td>{{k.money}}</td>
            <td>{{k.time}}</td>
          </tr>
        </table>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  props: {
    row: Object
  }
};
</script>